import CAButton from '@ds/components/buttons/CAButton'
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'ListViewFolderView',

	emits: { show: (_value: 'folder' | 'list') => true },

	render() {
		return (
			<p>
				<CAButton
					buttonStyle="filled-light"
					class="mr-2"
					dataTest="folder-view-link"
					text="Folder View"
					onClick={() => this.$emit('show', 'folder')}
				/>

				<CAButton
					buttonStyle="filled-light"
					dataTest="list-view-link"
					text="List View"
					onClick={() => this.$emit('show', 'list')}
				/>
			</p>
		)
	},
})
